import router from './router'
import store from './store'
import {
  setProject,
  setInviter,
  getToken,
  setCompany,
  setToken,
  getQueryString
} from '@/utils/auth' // 验权

router.beforeEach((to, from, next) => {
  if (navigator.userAgent.toLowerCase().includes('toutiaomicroapp')) {
    store.dispatch('user/RefreshMiniApp', true)
  } else {
    store.dispatch('user/RefreshMiniApp', false)
  }
  let project = getQueryString('project') || to.query.project
  if (project) {
    setProject(project)
  }
  let company = getQueryString('company') || to.query.company
  if (company) {
    setCompany(company)
  }
  let userId = getQueryString('userId') || to.query.userId
  if (userId) {
    setToken(userId)
  }
  let inviter = getQueryString('inviter') || to.query.inviter
  if (inviter) {
    setInviter(inviter)
  }
  next()
})

/** 只有在有code之后再进行登录 */
router.afterEach((to, from) => {
  // let code = getQueryString('code') || to.query.code
  // let token = getToken()
  // if (!token) {
  //   if (code) {
  //     store.dispatch('user/Login', code)
  //   }
  // }
})



// WEBPACK FOOTER //
// ./src/permission.js